'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isAddressLoading = isAddressLoading;
exports.isLoaded = isLoaded;
exports.loadProvince = loadProvince;
exports.loadProvinceServer = loadProvinceServer;
exports.loadDistrict = loadDistrict;
exports.handleDistrictFilter = handleDistrictFilter;
exports.changeAddress = changeAddress;
exports.changeProvince = changeProvince;
exports.changeDistrict = changeDistrict;

var _lodash = require('lodash');

var _ApiServer = require('helpers/ApiServer');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'lookme/address/LOAD';
var LOAD_SUCCESS = 'lookme/address/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/address/LOAD_FAIL';
var LOAD_DISTRICT = 'lookme/address/LOAD_DISTRICT';
var LOAD_DISTRICT_SUCCESS = 'lookme/address/LOAD_DISTRICT_SUCCESS';
var LOAD_DISTRICT_FAIL = 'lookme/address/LOAD_DISTRICT_FAIL';

var CHANGE_PROVINCE = 'lookme/address/CHANGE_PROVINCE';
var CHANGE_DISTRICT = 'lookme/address/CHANGE_DISTRICT';
var CHANGE_ADDRESS_FILTER = 'lookme/address/CHANGE_ADDRESS_FILTER';
var HANDLE_DISTRICT_FILTER = 'lookme/address/HANDLE_DISTRICT_FILTER';
var initialState = {
  provinceOptions: null,
  provinces: null,
  districts: null,
  province: '79',
  district: null,
  loadAddressError: null,
  loaded: false,
  district_loaded: false,
  addressFilter: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        provinces: action.result,
        provinceOptions: _support.Helper.provinceToOptions(action.result),
        loadAddressError: null,
        loaded: true
      });
    case LOAD_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            loading: false,
            loadAddressError: action.error,
            loaded: true
          });
        }
      }
    case LOAD_DISTRICT:
      return (0, _extends3.default)({}, state, {
        district_loading: true,
        district_parent: action.province_code
      });
    case LOAD_DISTRICT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        district_loading: false,
        districts: action.result,
        districtOptions: _support.Helper.districtToOptions(action.result),
        addressFilter: [],
        loadDistrictError: null,
        district_loaded: true
      });
    case LOAD_DISTRICT_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            district_loading: false,
            loadDistrictError: action.error,
            district_loaded: true
          });
        }
      }
    case CHANGE_PROVINCE:
      return (0, _extends3.default)({}, state, {
        province: action.data,
        addressFilter: []
      });
    case CHANGE_DISTRICT:
      return (0, _extends3.default)({}, state, {
        district: action.data
      });
    case HANDLE_DISTRICT_FILTER:
      return (0, _extends3.default)({}, state, {
        addressFilter: action.addressFilter
      });
    case CHANGE_ADDRESS_FILTER:
      return (0, _extends3.default)({}, state, {
        addressFilter: action.addressFilter
      });
    default:
      return state;
  }
}
function isAddressLoading(globalState) {
  return globalState.address && globalState.address.loading;
}
function isLoaded(globalState) {
  return globalState.address && globalState.address.loaded;
}

function loadProvince() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/address/load-province');
    }
  };
}

function loadProvinceServer() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise() {
      return _ApiServer.server.get('/address/load-province');
    }
  };
}
function loadDistrict(province) {
  return {
    types: [LOAD_DISTRICT, LOAD_DISTRICT_SUCCESS, LOAD_DISTRICT_FAIL],
    province_code: province,
    promise: function promise(client) {
      return client.get('/address/load-district?province_code=' + province);
    }
  };
}

function changeAddressFilter(addressFilter, code) {
  if (Array.isArray(addressFilter) && code) {
    if (addressFilter.indexOf(code) === -1) {
      return (0, _lodash.union)(addressFilter, [String(code)]);
    }
    return (0, _lodash.without)(addressFilter, String(code));
  }
  return [];
}

function handleDistrictFilter(addressFilter, code) {
  return {
    type: HANDLE_DISTRICT_FILTER,
    addressFilter: changeAddressFilter(addressFilter, code)
  };
}
function changeAddress(address) {
  return {
    type: CHANGE_ADDRESS_FILTER,
    addressFilter: address
  };
}
function changeProvince(province) {
  return {
    type: CHANGE_PROVINCE,
    data: province
  };
}
function changeDistrict(district) {
  return {
    type: CHANGE_DISTRICT,
    data: district
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/address.js
// module id = 64
// module chunks = 0